import React, { useEffect, useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
const Shade = ({shade}) => {
    const [copied,setcopied]=useState(false);
    useEffect(()=>{
        let interval;
        if(copied==true){

        interval=setInterval(()=>{
            setcopied(false);
        },1500)
return()=>{
    clearInterval(interval)
}
        }
    },[copied])
  return (
<CopyToClipboard text={shade.hexString()} onCopy={()=>setcopied(true)}>
<div className='shade' style={{backgroundColor:shade.hexString()}}>
    {
        copied?(
        <span className="copied">copied!!!</span>):(
        <span>{shade.hexString()}</span>)
}</div>

</CopyToClipboard>  )
}

export default Shade